import React from "react";
import MaterialItemList from "./MaterialItemList";
import { Typography } from "@mui/material";

const ManageMaterialInventoryForm: React.FC = () => {
    return (
        <div className="manage-material py-8">
            <hr className="py-2 border-gray-300 dark:border-gray-700"/>
            <Typography
                className="text-lg py-4"
                variant="h5"
                component="h2"
                gutterBottom
            >
                Manage Materials
            </Typography>
            <MaterialItemList/>
        </div>
    );
};

export default ManageMaterialInventoryForm;